// extracted by mini-css-extract-plugin
module.exports = {"container":"zOlGY","small":"_20T4r","medium":"_3wrI2","big":"_2N-pV","extraBig":"_2iBpW"};